import { Injectable } from '@angular/core';
import { FspSubjectRequestGridDto } from './fsp-subject-request-grid-data-model';
import { GridDataService } from '../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspSubjectRequestGridDataService extends GridDataService<FspSubjectRequestGridDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
